import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { TrendArrowDesktop as TrendArrow } from '@alfa-bank/site-invest-ui/components/icon-trend-arrow-desktop';
import { ProfitabilityRenderer } from '@alfa-bank/site-invest-ui/components/renderer';
import { EMPTY_VALUE_TEXT } from '@alfa-bank/site-invest-emitents-common/constants';
import { isNumber } from '@alfa-bank/site-invest-common/helpers/numbers/is-number';

import { defaultDividendBannerTexts } from '../../../configs';
import { getDividendsInfo } from '../../../helpers';
import type { IDividendCellProps } from '../models';
import styles from '../styles.css';

export const ProfitabilityPercentDesktop: FC<IDividendCellProps> = ({ asset }) => {
    const { profitabilityPercent } = getDividendsInfo(asset);

    if (!profitabilityPercent) {
        return null;
    }

    const { title } = defaultDividendBannerTexts.cells.profitabilityPercentDesktop;

    const hasPercentValue = isNumber(profitabilityPercent);

    return (
        <>
            <Grid colAutoWidth collapse justify="start">
                <Text styler={{ margin: 0 }} view="accent-primary-medium">
                    <ProfitabilityRenderer
                        fallbackValue={EMPTY_VALUE_TEXT}
                        value={profitabilityPercent}
                    />
                </Text>
                {hasPercentValue && profitabilityPercent !== 0 && (
                    <div className={styles.arrow}>
                        <TrendArrow up={profitabilityPercent > 0} />
                    </div>
                )}
            </Grid>
            <Grid alignment="center" colAutoWidth collapse justify="start">
                <Text
                    className={cn(styles.external, styles.text)}
                    styler={{ margin: 0 }}
                    view="primary-small"
                >
                    {title}
                </Text>
            </Grid>
        </>
    );
};
